import axios from "axios";

import baseDomain, {
  sendAudioNotificationAPI,
} from "../../Constants/apiRoutes";

export const sendAudioNotificationReq = (musicID) => {
  return axios.post(`${baseDomain}${sendAudioNotificationAPI}/${musicID}`);
};